module.exports = __webpack_public_path__ + "img/341.44d1f4c.png";